import React, { useState, useContext } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from "@material-ui/core";

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";


const AddCompare = (props) => {
  const emptyCompare = { title: "", status: "draft" };
  const [newCompare, setNewCompare] = useState({ ...emptyCompare });
  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);

  const addCompare = () => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/compares`,
      data: newCompare,
      method: 'post',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        if (props.newCompareCallback)
          props.newCompareCallback()

        props.setAddCompareDialogOpen(false);
        setNewCompare({ ...emptyCompare });
        pageContext.setInfoMessage(
          "Erledigt! Finanzierungsantrag " +
          newCompare.title +
          " wurde angelegt."
        );
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("Finanzierungsantrag konnte nicht angelegt werden!");
      });
  }

  return (
    <Dialog
      open={props.addCompareDialogOpen === true}
      onClose={() => {
        props.setAddCompareDialogOpen(false);
      }}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Neuer Kreditvergleich</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Gib dem Dokument eine aussagekräftige Bezeichnung
        </DialogContentText>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Bezeichnung"
              name="title"
              id="title"
              value={newCompare.title ? newCompare.title : ""}
              required={true}
              helperText="zB Einfamilienhaus Familie Muster..."
              fullWidth
              onChange={(e) => setNewCompare({ ...newCompare, [e.target.name]: e.target.value })}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.setAddCompareDialogOpen(false);
          }}
          variant="outlined"
          color="primary"
        >
          Abbrechen
        </Button>
        <Button
          onClick={() => {
            addCompare();
          }}
          variant="outlined"
          color="primary"
          disabled={
            newCompare.title === ""
          }
        >
          Neuen Kreditvergleich anlegen
        </Button>
      </DialogActions>
    </Dialog>
  )
};

export default AddCompare;